import { v4 as uuid } from 'uuid';
import { WidgetType } from '../../../../Widget';
import { WidgetSelectFilters } from '../../../../select/WidgetSelectFilters';
import { WidgetRepository } from '../../../WidgetRepository';
import { ITableColumnWidget } from '../ITableInputWidget';

/**
 * Crea una colonna di tipo TableColumnType a partire da un widgetType
 * per poter inizializzare i valori quando viene aggiunta alla tabella.
 */
export function createTableWidgetInitialColumn(
  widgetType: WidgetType,
  values: { label: string; code: string },
): ITableColumnWidget | null {
  const { label, code } = values;
  const widget = WidgetRepository.find(widgetType);

  if (!widget) {
    console.error(`[CreateColumnType] Nessun widget con tipo: "${widgetType}"`); // prettier-ignore
    return null;
  }

  if (!WidgetSelectFilters.TableColumn(widget)) {
    console.error(`[CreateColumnType] Il widget con tipo: "${widgetType}" non è compatibile con TableColumn`); // prettier-ignore
    return null;
  }

  const baseWidget: ITableColumnWidget = {
    id: uuid(),
    type: widgetType as any,
    code: code,
    label: [{ type: 'text', text: label }],
    // Impostato isTableColumn a true di default, sappiamo che il widget é interno ad una tabella
    layout: { isTableColumn: true },
  };

  const result =
    widget.configValidator?.cast(baseWidget, { assert: false }) ?? baseWidget;

  return result;
}
